import { CommonPagination, FlexRow } from "components";
import { VideoCard } from "./details";

export const VideoGridView = ({ data, onOpen, onRestore, filter, total, pageChanged, pageSizeChanged, openReviewModal }) => (
    <div className="mt-3 row">
        {data.map(ele => (
            <div key={ele._id} className="col-12 col-md-6 col-lg-6 col-xl-4 mb-5">
                <VideoCard
                    {...(openReviewModal && {
                        openReviewModal: () =>
                            openReviewModal(ele),
                    })}
                    item={ele}
                    onOpen={() => onOpen(ele)}
                    toggleBlock={onRestore}
                />
            </div>
        ))}
        {
            total !== 0 &&
            <FlexRow className="justify-content-end mb-4">
                <CommonPagination page={filter.page} pageSize={filter.limit} pageChanged={pageChanged} pageSizeChanged={pageSizeChanged} total={total} />
            </FlexRow>
        }
    </div>
);